import { useQuery } from '@apollo/client';
import { graphql } from '@gql/gql';
import type {
  AccountGetBuyerDraftAnimalsQuery,
  AccountGetBuyerDraftAnimalsQueryVariables,
} from '@gql/graphql';

export const ACCOUNT_GET_BUYER_DRAFT_ANIMALS = graphql(`
  query AccountGetBuyerDraftAnimals($where: AnimalWhereInput) {
    accountMe {
      id
      animals(where: $where, take: 1) {
        id
      }
    }
  }
`);

export const useGetBuyerDraftAnimals = () => {
  const { data, loading, refetch } = useQuery<
    AccountGetBuyerDraftAnimalsQuery,
    AccountGetBuyerDraftAnimalsQueryVariables
  >(ACCOUNT_GET_BUYER_DRAFT_ANIMALS, {
    variables: {
      where: {
        name: { equals: null },
      },
    },
    ssr: false,
    fetchPolicy: 'no-cache',
  });

  return {
    draftAnimals: data?.accountMe?.animals ?? [],
    applicationsLoading: loading,
    applicationsRefetch: refetch,
  };
};
